//Types
import { ContainerWaveVariantsType } from '../../../designSystem/reloaded/commons/components/variants';
//Constants
import { CATEGORY_CONTROL } from '@kubit/web-ui-components';
export const argtypes = () => {
    return {
        variant: {
            description: 'Variant',
            type: { name: 'string', required: true },
            control: { type: 'select' },
            options: Object.keys(ContainerWaveVariantsType),
            table: {
                type: {
                    summary: 'string',
                },
                category: CATEGORY_CONTROL.MODIFIERS,
            },
        },
    };
};
//# sourceMappingURL=argtypes.js.map